export const equipmentData = ["Sport", "Luxury", "Standard", "xLine", "M Sport", "M Sport X", "Connected", "Advantage", "Charged", "Fully Charged", "Super Charged", "Charged Professional"];

export const equipmentDataMini = ["Classic", "Favoured", "JCW", "Essential", "Experience", "Maximise"];

export default equipmentData;
